import { mapActions, mapGetters, mapMutations } from "vuex";
import VueAdsPagination, { VueAdsPageButton } from "vue-ads-pagination";

import favouriteProduct from "../favourite/components/favourite-product/index.vue";

export default {
    name: "profile-favourite",
    data() {
        return {
            page: 0,
        };
    },
    head: {
        title: function() {
            return {
                inner: "Точка ",
                separator: "|",
                complement: "Вибрані",
            };
        },
    },
    components: {
        "favourite-product": favouriteProduct,
        VueAdsPagination,
        VueAdsPageButton,
    },
    watch: {
        skip() {
            if (this.skip === 0) {
                this.page = 0;
            }
        },
    },
    computed: {
        ...mapGetters({
            favouriteList: "favorites/whichList",
            favouriteListLoading: "favorites/whichListLoading",
            favouritesListLength: "favorites/favouritesListLength",
            favouritesLength: "favorites/favouriteLength",
            limit: "favorites/limit",
        }),
    },
    created() {
        if (!this.favouriteList) {
            this.fetchFavouriteList();
        }
    },
    methods: {
        ...mapActions({
            fetchFavouriteList: `favorites/GET_FAVORITES_LIST`,
        }),
        ...mapMutations({
            changePage: `favorites/FAVOURITES_CHANGE_PAGE`,
        }),
        changePageLocal(page) {
            this.page = page;
            this.changePage(page + 1);
            this.fetchFavouriteList();
            window.scroll({
                top: 0,
                left: 0,
                behavior: "smooth",
            });
        },
    },
};
